import React from "react";
import styles from "./LevelMenu.module.scss";
import { TranslateLanguage } from "util/Translate";
import { vocabLevelMenu } from "util/Translate.variable";
import useWindowSize from "hook/useWindowSize";
import { useDataStore } from "../../store/DataStoreContext";

const translate = new TranslateLanguage();
translate.addMaping(vocabLevelMenu);

const LevelMenu = (props) => {
  const { menuList = [], activeMenu, onClick, amountItem } = props;

  const {
    state: { educationType },
  } = useDataStore();
  const { width } = useWindowSize();

  const onActiveMenu = (key) => {
    let isActive = educationType.activeLevel === key;
    return {
      backgroundColor: isActive ? "#FF8CAF" : "#f4eff4",
      color: isActive ? "#FFF" : "#0A0D14",
    };
  };

  const transitionStyle = { transition: "background-color 0.3s, color 0.3s" };

  return (
    <div className={styles.level_menu_container}>
      <div
        className={styles.container}
        style={{ gridTemplateColumns: `repeat(${amountItem}, 1fr)` }}
      >
        {menuList?.map((lg) => (
          <div
            key={lg.id}
            onClick={() => onClick(lg.id)}
            style={onActiveMenu(lg.id)}
            className={`${styles.button_menu} ${
              educationType.activeLevel === lg.id ? "clicked" : ""
            }`}
          >
            <div
              className={styles.logo}
              style={
                educationType.activeLevel === lg.id
                  ? { backgroundColor: "#FFFFFF" }
                  : { backgroundColor: "#EE5294" }
              }
            >
              <img
                src={lg.icon}
                alt="logo"
                className={styles.img}
                style={
                  educationType.activeLevel === lg.id
                    ? {}
                    : {
                        filter: "brightness(0) invert(1)",
                      }
                }
              />
            </div>
            {lg.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LevelMenu;
